import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class AetQuizPlaceholderService extends BaseService {
  constructor() {
    super(constants.FETCH_AET_QUIZ_PLACEHOLDER, 'AetQuizPlaceholderService');
  }

  handleEvent(eventName, event) {
    // API call to fetch AET Quiz placeholder text
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId,
      Accept: 'text/plain'
    };
    return this.getClient('aiadminv2').get(constants.AET_QUIZ_PLACEHOLDER_URL, {
      headers,
      timeout: 10000
    });
  }

  handleResponse(response) {
    const { data } = response;
    const placeholderText =
      typeof data === 'string' && data.trim() ? data.trim() : constants.DEFAULT_COMMENT_PLACEHOLDER;

    // Store in MobX state
    Framework.getStoreRegistry().getStore('aetQuizUtility').setCommentPlaceholder(placeholderText);
  }

  handleError(error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to fetch AET Quiz placeholder text from API:', error.message);

    // Set default placeholder on error
    Framework.getStoreRegistry()
      .getStore('aetQuizUtility')
      .setCommentPlaceholder(constants.DEFAULT_COMMENT_PLACEHOLDER);
  }
}
